export default {
  unavailable: {
    title: 'Ce service est opéré par Foodamigos',
    description:
      "L'impression de flyers et d'autocollants est un service opéré par l'équipe Foodamigos et n'est pas disponible pour les comptes partenaires.",
  },
};
